module.exports = __webpack_public_path__ + "bad3bcf6dc8a01c71c9b7d62fa9a20ed.jpg";